import { Store, Task } from '@/model/types'
import { taskEdge } from '@/utils/geometry'
import * as v2 from '@/utils/vector2'
import { Component, Emit, Inject, Prop, Vue } from 'vue-property-decorator'
import ProjectEditor, { GraphCoordinates } from './ProjectEditor'

@Component({})
export default class DependencyEdge extends Vue {
  @Prop() private prereq!: Task;
  @Prop() private dependent!: Task;
  // We only need the store to get the camera's current zoom. This could
  // probably be cleaned up by moving the camera back into Store and using the
  // injected ProjectEditor in the minimap component.
  @Prop() private store!: Store;

  @Inject() private editor!: ProjectEditor;

  private showActions = false

  private mouseEnter () {
    this.showActions = true
  }

  private mouseLeave () {
    this.showActions = false
  }

  @Emit('delete')
  private handleDelete () {
    this.showActions = false
  }

  private get computed () {
    const to = this.dependent
    const from = this.prereq

    const delta = v2.subtract(to, from)
    const deltaAngle = v2.direction(delta)
    const edgeOffset = v2.divide(taskEdge(deltaAngle, false), this.store.camera.zoom)
    const start = this.editor.graphToElement(v2.add(from, edgeOffset) as GraphCoordinates)
    const end = this.editor.graphToElement(v2.subtract(to, edgeOffset) as GraphCoordinates)
    const angle = v2.direction(v2.subtract(start, end))

    return {
      start: start,
      end: end,
      center: v2.divide(v2.add(start, end), 2),
      arrowTranslate: `translate(${end.x}, ${end.y}) rotate(${angle * 180 / Math.PI})`
    }
  }
}
